import { SessionStorage } from "./util/SessionStorage";

// const schoolId = SessionStorage.getItem("school_id");
const menuItems2 = {
    items: [
      {
        id: 'management-panel',
        title: 'Management Panel',
        type: 'group',
        icon: 'icon-monitor',
        children: [
          {
            id: 'sch-addSchool',
            title: 'Settings',
            icon: 'feather icon-settings',
            type: 'item',
            url: `/teacher-portal/editSchool`
            // children: [
            //   {
            //     id: 'active-schools',
            //     title: 'Active Schools',
            //     type: 'item',
            //     url: '/admin-portal/active-schools'
            //   },
            //   {
            //     id: 'archived-schools',
            //     title: 'Archived Schools',
            //     type: 'item',
            //     url: '/admin-portal/archived-schools'
            //   }
            // ]
          },
          {
            id: 'users',
            title: 'Users',
            type: 'collapse',
            icon: 'feather icon-users',
            children: [
              {
                id: 'active-users',
                title: 'Active Users',
                type: 'item',
                url: '/teacher-portal/active-users'
              },
              {
                id: 'archived-users',
                title: 'Archived Users',
                type: 'item',
                url: '/teacher-portal/archived-users'
              }
            ]
          },
    ] 
  }
]
};
  
  export default menuItems2;
  